export default __webpack_public_path__ + "static/media/log_out.aa365149.svg";